import { render, staticRenderFns } from "./MessageTemplateListView.vue?vue&type=template&id=b938d7a6&scoped=true"
import script from "./MessageTemplateListView.vue?vue&type=script&lang=ts"
export * from "./MessageTemplateListView.vue?vue&type=script&lang=ts"
import style0 from "./MessageTemplateListView.vue?vue&type=style&index=0&id=b938d7a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b938d7a6",
  null
  
)

export default component.exports